<div class="container-fluid cw-background">
  <mat-card class="mat-elevation-z8 mt-3 mb-5">
    <mat-card-title class="title-page">User List</mat-card-title>
    <button *ngIf="currentUser.canCreateUser()" mat-fab class="create" color="accent" (click)="onAddUser()">
      <mat-icon>add</mat-icon>
    </button>
    <mat-card-content class="mt-4">
      <div class="container-fluid">
        <app-data-table
          *ngIf="tableConfig"
          [config]="tableConfig"
          (getData)="userTableService.getUsers($event)"
          (updateData)="userTableService.update($event)"
        ></app-data-table>
      </div>
    </mat-card-content>
  </mat-card>
</div>
